import Colors from "../../../assets/Variables/ColorsVariables.js";
import { Spaces } from "../../../assets/Variables/SpaceVariables.js";

export const containerPaper = {

  display: "flex",
  flexDirection: "column",
  padding: "20px",
  width: "calc(100vw - 280px)",
  maxWidth: "90%",
  minWidth: "1100px",
  borderRadius: "12px",
  margin: "0 auto",
  height: "900px"
}
export const loading = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "450px",
}

export const ExportButton = {

  fontFamily: "Plus Jakarta Sans, sans-serif",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  textTransform: "none",
  minWidth: "82px",
  height: "35px",
  padding: `${Spaces.Size_3} 8px`,
  borderRadius: Spaces.Size_2,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  color: Colors.Gray_900,
  backgroundColor: "#FFFFFF",
  border: `1px solid ${Colors.Gray_900}`,
  "&:hover": {
    backgroundColor: "#FFFFFF",
    border: `1px solid ${Colors.Gray_900}`,
  },
}

export const ActionsButton = {

  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "700",
  color: '#15202A',
  border: 'none',
  borderRadius: '8px',
  textTransform: 'none',
}

export const TicketButton = {

  minWidth: "auto",
  padding: "4px 8px",
  borderRadius: "6px",
  fontFamily: "Plus Jakarta Sans",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: "700",
  color: Colors.Info_700,
  border: 'none',
  borderRadius: '8px',
  textTransform: 'none',
}

export const AddButton = {

  minWidth: "123px",
  height: "35px",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "row",
  gap: "8px",
  paddingInline: Spaces.Size_3,
  paddingBlock: 0,
  borderRadius: Spaces.Size_2,
  backgroundColor: Colors.Error_500,
  color: Colors.Warning_50,
  textTransform: "none",
  "&:hover": {
    backgroundColor: Colors.Error_500,
    opacity: 0.9,
  },
}